var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"element",staticClass:"video"},[(_vm.display)?_c('iframe',{attrs:{"width":_vm.width,"height":_vm.height,"src":_vm.url,"frameborder":"0","allow":"autoplay; encrypted-media","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_supports-color@4.5.0__css-loader@0.28.11_lodash@4.1_0dba4eeb2dbfa95bd942c2dd5fdbdc4d/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f5c3a12","hasScoped":false,"buble":{"transforms":{}}}!./resources/assets/front/js/components/jj-video/template.html
// module id = 197
// module chunks = 14